import { getAdminPanelBaseUrl } from '../constants/adminPanel';

export const CONSENT_FORM_PATH = '/consent';
export const CONSENT_FORMS_ADMIN_PATH = '/consent-forms';
export const CONSENT_FORM_VERSION = '1';

export const CONSENT_FORM_FIELD_LIMITS = {
  name: 120,
  age: 20,
  gender: 80,
  postcode: 16,
  ethnicity: 80,
  email: 254,
  signature: 120,
  parentGuardian: 120,
  formVersion: 16,
  workshopId: 80,
} as const;

export function isConsentPublicPath(pathname: string): boolean {
  const path =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return path === CONSENT_FORM_PATH;
}

export function getConsentFormPath(): string {
  return CONSENT_FORM_PATH;
}

export function getConsentFormUrl(origin = getAdminPanelBaseUrl()): string {
  return `${origin}${CONSENT_FORM_PATH}`;
}

export function parsedAge(age: string): number | null {
  const trimmed = age.trim();
  if (!/^\d{1,3}$/.test(trimmed)) {
    return null;
  }
  const value = Number(trimmed);
  if (!Number.isInteger(value) || value < 0 || value > 120) {
    return null;
  }
  return value;
}

export function isUnder18(age: string): boolean {
  const value = parsedAge(age);
  return value !== null && value < 18;
}

export function sanitiseWorkshopId(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? '';
  if (!/^[A-Za-z0-9_-]{1,80}$/.test(trimmed)) {
    return '';
  }
  return trimmed;
}
